export const ISSUE_SCORE_ONE = 1
export const ISSUE_SCORE_TWO = 2
export const ISSUE_SCORE_THREE = 3
export const ISSUE_SCORE_FOUR = 4
export const ISSUE_SCORE_FIVE = 5
export const ISSUE_SCORE_SIX = 6
export const ISSUE_SCORE_EIGHT = 8
export const ISSUE_SCORE_NINE = 9
export const ISSUE_SCORE_TEN = 10
export const ISSUE_SCORE_TWELVE = 12
export const ISSUE_SCORE_FIFTEEN = 15
export const ISSUE_SCORE_SIXTEEN = 16
export const ISSUE_SCORE_TWENTY = 20
export const ISSUE_SCORE_TWENTY_FIVE = 25
export const ISSUE_SCORE_SEVEN = 7
export const ISSUE_SCORE_ELEVEN = 11
export const ISSUE_SCORE_THIRTEEN = 13
export const ISSUE_SCORE_FOURTEEN = 14
export const ISSUE_SCORE_SEVENTEEN = 17
export const ISSUE_SCORE_EIGHTEEN = 18
export const ISSUE_SCORE_NINETEEN = 19
export const ISSUE_SCORE_TWENTY_ONE = 21
export const ISSUE_SCORE_TWENTY_TWO = 22
export const ISSUE_SCORE_TWENTY_THREE = 23
export const ISSUE_SCORE_TWENTY_FOUR = 24

export const IMPACT_VALUE = [ 5, 4, 3, 2, 1 ]
export const PROBABILITY_VALUE = [ 1, 2, 3, 4, 5 ]

export const IMPACT_VALUE_THREE_CROSS = [ 3, 2, 1 ]
export const PROBABILITY_VALUE_THREE_CROSS = [ 1, 2, 3 ]

export const ISSUE_TABLE_HEADERS = [

    {
        field: 'title',
        headerName: 'Issue',
        width: 150,
        editable: false
    },
    {
        field: 'description',
        headerName: 'Description',
        editable: false
    },
    {
        field: 'raisedDepartment',
        headerName: 'Raised Dept',
        width: 150
    },
    {
        field: 'raisedBy',
        headerName: 'Raised By',
        width: 150,
        editable: false
    },
    {
        field: 'type',
        headerName: 'Type',
        width: 150,
        editable: false
    },
    {
        field: 'createdDate',
        headerName: 'Created Date',
        width: 150
    },
    {
        field: 'impactedDepartment',
        headerName: 'Impacted Dept',
        width: 250
    },
    {
        field: 'riskOwner',
        headerName: 'Issue Owner',
        width: 150
    },
    {
        field: 'aging',
        headerName: 'Age',
        width: 150,
        editable: false
    },

    // {
    //     field: 'category',
    //     headerName: 'Category',
    //     width: 150,
    //     editable: false
    // },
    // {
    //     field: 'periodicity',
    //     headerName: 'Periodicity',
    //     width: 150
    // },
    {
        field: '',
        headerName: '',
        width: 50,
        description: 'This column has a value getter and is not sortable.',
        sortable: false
    }
]
export const DOT = 'dot'
export const ISSUE_RATINNG = [
    { title: 'Very Low', color: 'hsl(var(--Controlled))' },
    { title: 'Low', color: 'hsl(var(--Low))' },
    { title: 'Medium', color: 'hsl(var(--Medium))' },
    { title: 'High', color: 'hsl(var(--High))' },
    { title: 'Very High', color: 'hsl(var(--Extreme))' }
]
export const ISSUE_RATINNG_THREE_CROSS = [
    { title: 'Low', color: 'hsl(var(--Low))' },
    { title: 'Medium', color: 'hsl(var(--Medium))' },
    { title: 'Very High', color: 'hsl(var(--Extreme))' }
]

export const ISSUE_LEVEL_VERY_LOW = 'Very Low'
export const ISSUE_LEVEL_LOW = 'Low'
export const ISSUE_LEVEL_MEDIUM = 'Medium'
export const ISSUE_LEVEL_HIGH = 'High'
export const ISSUE_LEVEL_VERY_HIGH = 'Very High'
export const xLabels = [ 'Negligible', 'Minor', 'Moderate', 'Significant', 'Severe' ]
export const yLabels = [ 'Very High', 'High', 'Medium', 'Low', 'Very Low' ]

export const Y_LABLES_THREE_CROSS = [ 'Severe', 'Moderate', 'Minor' ]
export const X_LABLES_THREE_CROSS = [ 'Low', 'Medium', 'Very High' ]

export const CHIP_VERY_HIGH = 'Very High'
export const CHIP_HIGH = 'High'
export const CHIP_MEDIUM = 'Medium'
export const CHIP_LOW = 'Low'
export const CHIP_VERY_LOW = 'Very Low'

export const ISSUE_SCROING_DATA = [
    [ // Very High
        { value: 21, color: 'hsl(var(--Low))' },
        { value: 22, color: 'hsl(var(--High))' },
        { value: 23, color: 'hsl(var(--High))' },
        { value: 24, color: 'hsl(var(--Extreme))' },
        { value: 25, color: 'hsl(var(--Extreme))' }
    ],
    [ // High
        { value: 16, color: 'hsl(var(--Low))' },
        { value: 17, color: 'hsl(var(--Medium))' },
        { value: 18, color: 'hsl(var(--High))' },
        { value: 19, color: 'hsl(var(--High))' },
        { value: 20, color: 'hsl(var(--Extreme))' }
    ],
    [ // Medium
        { value: 11, color: 'hsl(var(--Low))' },
        { value: 12, color: 'hsl(var(--Low))' },
        { value: 13, color: 'hsl(var(--Medium))' },
        { value: 14, color: 'hsl(var(--High))' },
        { value: 15, color: 'hsl(var(--High))' }
    ],
    [ // Low
        { value: 6, color: 'hsl(var(--Controlled))' },
        { value: 7, color: 'hsl(var(--Low))' },
        { value: 8, color: 'hsl(var(--Low))' },
        { value: 9, color: 'hsl(var(--Medium))' },
        { value: 10, color: 'hsl(var(--High))' }
    ],
    [ // Very Low
        { value: 1, color: 'hsl(var(--Controlled))' },
        { value: 2, color: 'hsl(var(--Controlled))' },
        { value: 3, color: 'hsl(var(--Low))' },
        { value: 4, color: 'hsl(var(--Low))' },
        { value: 5, color: 'hsl(var(--Low))' }
    ]
]

export const ISSUE_SCROING_DATA_THREE_CROSS = [
    [{ value: 3, color: 'hsl(var(--Medium))' }, { value: 6, color: 'hsl(var(--Extreme))' }, { value: 9, color: 'hsl(var(--Extreme))' }],
    [{ value: 2, color: 'hsl(var(--Low))' }, { value: 4, color: 'hsl(var(--Medium))' }, { value: 6, color: 'hsl(var(--Extreme))' }],
    [{ value: 1, color: 'hsl(var(--Low))' }, { value: 2, color: 'hsl(var(--Low))' }, { value: 3, color: 'hsl(var(--Medium))' }]
]

export const TYPE = 'IssueType'
export const RISK_OWNER = 'OwnerDepartmentId'
export const SEVERITY_OF_ISSUE = 'SeverityOfIssue'
export const ISSUE_TAB = {
    ANALYZE_AND_PLAN: 'Analyze & Plan',
    MONITORING: 'Monitoring',
    PENDING_FOR_REVIEW: 'Pending for Review',
    CLOSE: 'Close'
}
export const ISSUE_STATUS = {
    ISSUE_INFO: 'issueInfo',
    ANALYZE: 'analyze',
    PLAN: 'planning',
    MONITORING: 'monitoring',
    PENDING_FOR_REVIEW: 'pendingForReview',
    CLOSE: 'close'
}
export const RESOLUTION_APPROACH = [
    { label: 'Invalid', value: 1 },
    { label: 'Duplicate', value: 2 },
    { label: 'Resolution', value: 3 }
]
export const INVALID_ID = 1
export const DUPLICATE_ID = 2
export const RESOLUTION_ID = 3
export const INVALID = 'Invalid'
export const DUPLICATE = 'Duplicate'
export const RESOLUTION = 'Resolution'
